import { useCallback, useState } from 'react'

import { useQueryList } from '@percent/utility'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { usePermissions } from '@percent/admin-dashboard/common/hooks/usePermissions'
import { SewaOnboardingTable } from './sewaOnboardingTable/SewaOnboardingTable'

export function SewaOnboardingContainer() {
  const { sewaOnboardingService } = useServices()
  const { userHasPermissions } = usePermissions()

  const canOnboard = userHasPermissions('donations:can_create_sewa')
  const canOffboard = userHasPermissions('donations:can_update_sewa')

  const [search, setSearch] = useState('')

  const [
    { data, isLoading, isFetching, totalResults, errorMessage },
    { nextPage, previousPage, refresh, refreshToFirstPage }
  ] = useQueryList(
    ['v1/admin/organisations/sewa-onboarding', search],
    sewaOnboardingService.getSewaOnboardingList,
    search ? { query: search } : {}
  )

  // `refreshToFirstPage` only strips cursor/page/next from queryData — if the user is already on
  // page 1, the resulting params are identical, the queryKey doesn't change, and react-query
  // won't refetch. After a successful onboard/offboard we want the table to actually reload,
  // so we also call `refresh` (react-query's `refetch`) to force one.
  const handleRefresh = useCallback(() => {
    refreshToFirstPage()
    refresh()
  }, [refresh, refreshToFirstPage])

  return (
    <SewaOnboardingTable
      data={data}
      isLoading={isLoading || isFetching}
      errorMessage={errorMessage}
      nextPage={nextPage}
      previousPage={previousPage}
      totalResults={totalResults ?? 0}
      refresh={handleRefresh}
      searchValue={search}
      onSearch={setSearch}
      canOnboard={canOnboard}
      canOffboard={canOffboard}
    />
  )
}
